package diana.soleil.design.iraniancanadienbazzar.feature.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FullScreenImageViewer
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.PeopleIntent
import diana.soleil.design.iraniancanadienbazzar.core.model.PublicProfile
import diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.inbox_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_connect
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_about
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_avatar_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_details
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_error
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_hometown
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_interests
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_lang_en
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_lang_fa
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_lang_fr
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_not_found_desc
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_not_found_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_photo_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_photo_counter
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_photos
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_relationship_in_relationship
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_relationship_married
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_relationship_single
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_retry
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_speaks
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.person_viewer_close_a11y
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/** A member's public profile (opt-in card, writ large) + Connect. Route: `Route.PersonProfile`. */
@Composable
fun PersonProfileRoute(
    uid: String,
    onBack: () -> Unit,
    onOpenConversation: (conversationId: String) -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: PersonProfileViewModel = koinViewModel(parameters = { parametersOf(uid) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.signInRequired) { if (state.signInRequired) { viewModel.consumeGate(); onRequireSignIn() } }
    LaunchedEffect(state.openConversationId) {
        val id = state.openConversationId ?: return@LaunchedEffect
        viewModel.consumeOpen(); onOpenConversation(id)
    }
    PersonProfileScreen(
        state = state,
        onBack = onBack,
        onConnect = viewModel::connect,
        onRetry = viewModel::load,
        modifier = modifier,
    )
}

@Composable
fun PersonProfileScreen(
    state: PersonProfileUiState,
    onBack: () -> Unit,
    onConnect: () -> Unit,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidth)
            .fillMaxHeight()
            .navigationBarsPadding(),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.primaryContainer)
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.inbox_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onPrimary,
            )
            Text(
                text = state.person?.displayName.orEmpty(),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onPrimary,
                modifier = Modifier.weight(1f),
            )
        }
        when {
            state.loading -> LoadingState()
            state.error -> ErrorState(
                message = stringResource(Res.string.person_error),
                onRetry = onRetry,
                retryLabel = stringResource(Res.string.person_retry),
            )
            state.person == null -> EmptyState(
                title = stringResource(Res.string.person_not_found_title),
                description = stringResource(Res.string.person_not_found_desc),
            )
            else -> PersonProfileContent(
                person = state.person,
                onConnect = onConnect,
                modifier = Modifier.weight(1f),
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PersonProfileContent(
    person: PublicProfile,
    onConnect: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var viewerIndex by remember { mutableStateOf<Int?>(null) }
    viewerIndex?.let { index ->
        FullScreenImageViewer(
            imageUrls = person.photos,
            startIndex = index,
            closeContentDescription = stringResource(Res.string.person_viewer_close_a11y),
            counterFormat = stringResource(Res.string.person_photo_counter),
            imageContentDescription = stringResource(Res.string.person_photo_a11y, person.displayName),
            onDismiss = { viewerIndex = null },
        )
    }
    Column(modifier = modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier
                .weight(1f)
                .fillMaxWidth()
                .verticalScroll(rememberScrollState())
                .padding(bottom = AppTheme.spacing.lg),
        ) {
            // Hero: big portrait on the primary band's tail so the photo pops against brand color.
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.primaryContainer)
                    .padding(bottom = AppTheme.spacing.lg),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                PersonAvatar(
                    id = person.uid,
                    name = person.displayName,
                    photoUrl = person.photoUrl,
                    size = AppTheme.sizes.avatarXl,
                    textStyle = AppTheme.typography.headlineLg,
                    contentDescription = stringResource(Res.string.person_avatar_a11y, person.displayName),
                )
                person.city?.takeIf { it.isNotBlank() }?.let {
                    Text(text = it, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onPrimary)
                }
                if (person.intents.isNotEmpty()) {
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                        person.intents.mapNotNull(PeopleIntent::fromWire).forEach { intent ->
                            AppChip(label = intent.label(), selected = true, onClick = {})
                        }
                    }
                }
            }
            person.bio?.takeIf { it.isNotBlank() }?.let { bio ->
                ProfileSection(title = stringResource(Res.string.person_about)) {
                    Text(text = bio, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurface)
                }
            }
            val details = buildList {
                person.occupation?.takeIf { it.isNotBlank() }?.let { add("work" to it) }
                relationshipLabel(person.relationship)?.let { add("favorite" to it) }
                person.hometown?.takeIf { it.isNotBlank() }?.let {
                    add("home" to stringResource(Res.string.person_hometown, it))
                }
                languagesLabel(person.languages)?.let {
                    add("translate" to stringResource(Res.string.person_speaks, it))
                }
            }
            if (details.isNotEmpty()) {
                ProfileSection(title = stringResource(Res.string.person_details)) {
                    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                        details.forEach { (icon, text) -> DetailRow(iconName = icon, text = text) }
                    }
                }
            }
            if (person.interests.isNotEmpty()) {
                ProfileSection(title = stringResource(Res.string.person_interests)) {
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                    ) {
                        person.interests.forEach { AppChip(label = it, selected = false, onClick = {}) }
                    }
                }
            }
            if (person.photos.isNotEmpty()) {
                ProfileSection(title = stringResource(Res.string.person_photos), padContent = false) {
                    LazyRow(
                        contentPadding = PaddingValues(horizontal = AppTheme.spacing.lg),
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        itemsIndexed(person.photos, key = { _, url -> url }) { index, url ->
                            BusinessCover(
                                imageUrl = url,
                                contentDescription = stringResource(Res.string.person_photo_a11y, person.displayName),
                                iconName = "photo_camera",
                                modifier = Modifier
                                    .width(AppTheme.sizes.compactItemCardWidth)
                                    .aspectRatio(4f / 3f)
                                    .clip(AppTheme.shapes.card)
                                    .clickable { viewerIndex = index },
                            )
                        }
                    }
                }
            }
        }
        AppButton(
            text = stringResource(Res.string.people_connect),
            onClick = onConnect,
            leadingIcon = "person_add",
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
        )
    }
}

@Composable
private fun ProfileSection(
    title: String,
    padContent: Boolean = true,
    content: @Composable () -> Unit,
) {
    Column(modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.lg)) {
        Text(
            text = title,
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onBackground,
            modifier = Modifier.padding(horizontal = AppTheme.spacing.lg),
        )
        val sidePadding = if (padContent) Modifier.padding(horizontal = AppTheme.spacing.lg) else Modifier
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = AppTheme.spacing.sm)
                .then(sidePadding),
        ) { content() }
    }
}

@Composable
private fun DetailRow(iconName: String, text: String) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surface, AppTheme.shapes.card)
            .padding(AppTheme.spacing.md),
    ) {
        AppIcon(
            name = iconName,
            contentDescription = null,
            tint = AppTheme.colors.primary,
            modifier = Modifier.size(AppTheme.sizes.iconMd),
        )
        Text(text = text, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurface)
    }
}

@Composable
private fun relationshipLabel(wire: String?): String? = when (RelationshipStatus.fromWire(wire)) {
    RelationshipStatus.Single -> stringResource(Res.string.person_relationship_single)
    RelationshipStatus.InRelationship -> stringResource(Res.string.person_relationship_in_relationship)
    RelationshipStatus.Married -> stringResource(Res.string.person_relationship_married)
    null -> null
}

/** Localized "Farsi, English" list; unknown codes pass through as-is so data never disappears. */
@Composable
private fun languagesLabel(codes: List<String>): String? {
    if (codes.isEmpty()) return null
    // Resolve the known labels up front — joinToString's lambda is not a composable context.
    val labels = mapOf(
        "en" to stringResource(Res.string.person_lang_en),
        "fa" to stringResource(Res.string.person_lang_fa),
        "fr" to stringResource(Res.string.person_lang_fr),
    )
    return codes.joinToString(", ") { labels[it] ?: it }
}
